import { ComponentProps } from 'react';
import clsx from 'clsx';

import {
  OpDataFetchTransfer,
  ExistingItemIdsEndpoint,
} from 'new-components/DLS/OpDataFetchTransfer/OpDataFetchTransfer';
import { OpSkeleton } from 'new-components/DLS/OpSkeleton/OpSkeleton';

import { useOpFormContext } from '../../OpFormContext';
import { OpForm } from '../../OpForm';

import './OpFormDataFetchTransfer.scss';

interface OpFormDataFetchTransferProps<
  T extends Api.JsonOperation,
  U extends Api.JsonOperation,
  K extends ExistingItemIdsEndpoint,
> extends Pick<
      ComponentProps<typeof OpForm.Item>,
      | 'name'
      | 'label'
      | 'tooltip'
      | 'rules'
      | 'validateTrigger'
      | 'validateStatus' // Temp: For SUIR wrapped version
      | 'help' // Temp: For SUIR wrapped version
      | 'required' // Temp: For SUIR wrapped version
    >,
    ComponentProps<typeof OpDataFetchTransfer<T, U, K>> {
  formItemClassName?: string;
  isLoading?: boolean;
}

export const OpFormDataFetchTransfer = <
  T extends Api.JsonOperation,
  U extends Api.JsonOperation,
  K extends ExistingItemIdsEndpoint,
>({
  // Form Item props
  name,
  label,
  tooltip,
  rules,
  validateTrigger,
  formItemClassName,
  required, // TEMP: For old form component validation
  validateStatus, // TEMP: For old form component validation
  help, // TEMP: For old form component validation

  // For skeleton loading state
  isLoading,

  // Wrapped element props
  disabled,

  ...transferProps
}: OpFormDataFetchTransferProps<T, U, K>) => {
  /** The Form is wrapped in a provider that passes the loading context
   *  to the component */
  const { isDataLoading, isReadOnly } = useOpFormContext();

  return (
    <OpForm.Item
      className={clsx('op-form-data-fetch-transfer', formItemClassName)}
      name={name}
      label={!transferProps.collapsible ? label : undefined}
      tooltip={tooltip}
      rules={rules}
      validateTrigger={validateTrigger}
      required={required} // TEMP: For old form component validation
      validateStatus={validateStatus} // TEMP: For old form component validation
      help={help} // TEMP: For old form component validation
    >
      {isDataLoading || isLoading ? (
        <OpSkeleton.Input active block />
      ) : (
        <OpDataFetchTransfer<T, U, K>
          disabled={isReadOnly || disabled}
          {...transferProps}
        />
      )}
    </OpForm.Item>
  );
};
